(function () {
  'use strict';

  function track(event, detail) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: 'kfinder_' + event }, detail || {}));
    } catch (e) { /* no-op */ }
  }

  // Mode-router : bascule client-side entre les experiences finder sur
  // /pages/trouver-ma-piece (Shopify Liquid ne lit pas les query params en SSR).
  //  - mode=piece     -> experience "Par type de piece" (section k-finder-piece)
  //  - defaut / marque-modele -> finder marque/modele (section principale)
  // Les experiences sont rendues en SSR (crawlables) ; on ne fait que gerer
  // la visibilite. Le catalogue/recherche utilise directement ?view=trouver-piece-v3.
  function retitrer(el, balise) {
    if (!el || el.tagName.toLowerCase() === balise) return;
    var nouveau = document.createElement(balise);
    for (var i = 0; i < el.attributes.length; i++) nouveau.setAttribute(el.attributes[i].name, el.attributes[i].value);
    while (el.firstChild) nouveau.appendChild(el.firstChild);
    el.parentNode.replaceChild(nouveau, el);
  }

  function routeMode() {
    var params = new URLSearchParams(window.location.search);
    var mode = params.get('mode');
    // 30/10 : une requete (?mode=piece&q=joints) va toujours a la page de resultats du
    // moteur commun, jamais a la grille des types qui l'ignorait.
    if ((params.get('q') || '').trim() && params.get('view') !== 'trouver-piece-v3') {
      params.set('view', 'trouver-piece-v3');
      params.set('mode', 'piece');
      window.location.replace(window.location.pathname + '?' + params.toString());
      return;
    }
    var marque = document.querySelector('.k-finder-marque-modele-section');
    var piece = document.querySelector('[data-kfp]');
    if (mode === 'piece') {
      if (marque) marque.hidden = true;
      if (piece) { piece.hidden = false; piece.removeAttribute('aria-hidden'); }
      // 02/11 (controle visuel P1 5) : un seul h1 visible, celui du Finder par type de piece.
      retitrer(marque && marque.querySelector('h1'), 'h2');
      retitrer(piece && piece.querySelector('.kfp__title'), 'h1');
      track('mode_piece', {});
    } else {
      if (piece) { piece.hidden = true; piece.setAttribute('aria-hidden', 'true'); }
      if (marque) marque.hidden = false;
    }
  }

  function parseCatalog(root) {
    var brands = [];
    root.querySelectorAll('.kfc__brand').forEach(function (bEl) {
      var models = [];
      bEl.querySelectorAll('.kfc__model').forEach(function (mEl) {
        models.push({
          handle: mEl.getAttribute('data-model'),
          label: mEl.textContent.trim(),
          url: mEl.getAttribute('href'),
          type: mEl.getAttribute('data-type') || '',
          active: mEl.getAttribute('data-active') === 'true',
          priority: parseInt(mEl.getAttribute('data-priority') || '99', 10),
          schemas: mEl.getAttribute('data-schemas') || '',
          parts: mEl.getAttribute('data-parts') || ''
        });
      });
      models.sort(function (a, b) { return a.priority - b.priority; });
      brands.push({
        handle: bEl.getAttribute('data-brand'),
        label: bEl.getAttribute('data-label'),
        url: bEl.getAttribute('data-url'),
        models: models
      });
    });
    return brands;
  }

  var TYPE_LABELS = {
    'poele-bois': 'Poêle à bois',
    'poele-granules': 'Poêle à granulés',
    'insert': 'Insert'
  };

  function typeLabel(type) {
    if (!type) return '';
    if (TYPE_LABELS[type]) return TYPE_LABELS[type];
    return String(type)
      .replace(/[-_]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .replace(/^./, function (c) { return c.toUpperCase(); });
  }

  function init(finder) {
    var catalogEl = finder.querySelector('#k-finder-catalog');
    if (!catalogEl) return;
    var provisional = catalogEl.getAttribute('data-provisional') === 'true';
    var brands = parseCatalog(catalogEl);
    if (!brands.length) return;

    var controls = finder.querySelector('[data-kbmf-controls]');
    var brandSel = finder.querySelector('[data-kbmf-brand]');
    var modelSel = finder.querySelector('[data-kbmf-model]');
    var cta = finder.querySelector('[data-kbmf-cta]');
    var summary = finder.querySelector('[data-kbmf-summary]');
    var sBrand = finder.querySelector('[data-kbmf-summary-brand]');
    var sModel = finder.querySelector('[data-kbmf-summary-model]');
    var sType = finder.querySelector('[data-kbmf-summary-type]');
    var sCount = finder.querySelector('[data-kbmf-summary-count]');
    var empty = finder.querySelector('[data-kbmf-empty]');
    var emptyText = finder.querySelector('[data-kbmf-empty-text]');
    if (!controls || !brandSel || !modelSel || !cta) return;
    var ctaLibelle = cta.querySelector('[data-kbmf-cta-libelle]');

    // 01/11 (lot P1) : etat d'attente du systeme (Finder de l'accueil) : aria-disabled plutot
    // que disabled, le bouton dit ce qu'il attend puis devient l'action principale k-b1.
    function setCta(pret) {
      cta.setAttribute('aria-disabled', pret ? 'false' : 'true');
      cta.classList.toggle('k-b1', pret);
      cta.classList.toggle('k-b2', !pret);
      if (ctaLibelle) ctaLibelle.textContent = cta.getAttribute(pret ? 'data-libelle-pret' : 'data-libelle-attente');
    }

    // JS dispo: on montre les selects, on cache le fallback <a> brut.
    catalogEl.hidden = true;
    controls.hidden = false;

    brands.forEach(function (b) {
      var opt = document.createElement('option');
      opt.value = b.handle;
      opt.textContent = b.label;
      brandSel.appendChild(opt);
    });

    // 02/11 : marques sans modele d'appareil (conduits, accessoires), lues dans les donnees
    // du pipeline. Les choisir mene directement a leurs produits.
    var sansModele = [];
    try {
      var smEl = finder.querySelector('[data-kbmf-sans-modele]');
      sansModele = smEl ? JSON.parse(smEl.textContent || '[]') : [];
    } catch (e) { sansModele = []; }
    var connues = {};
    brands.forEach(function (b) { connues[b.handle] = true; });
    sansModele = sansModele.filter(function (m) { return m && m.handle && m.url && !connues[m.handle]; });
    if (sansModele.length) {
      var groupe = document.createElement('optgroup');
      groupe.label = 'Sans modèle à choisir';
      sansModele.forEach(function (m) {
        var opt = document.createElement('option');
        opt.value = 'sans-modele:' + m.handle;
        opt.textContent = m.metier ? m.label + ' (' + m.metier.toLowerCase() + ')' : m.label;
        groupe.appendChild(opt);
      });
      brandSel.appendChild(groupe);
    }
    function sansModeleChoisi() {
      var v = brandSel.value || '';
      if (v.indexOf('sans-modele:') !== 0) return null;
      var h = v.slice('sans-modele:'.length);
      return sansModele.filter(function (m) { return m.handle === h; })[0] || null;
    }

    function resetModels() {
      while (modelSel.options.length > 1) modelSel.remove(1);
      modelSel.options[0].textContent = 'Choisir votre modèle';
      modelSel.disabled = true;
      cta.setAttribute('data-libelle-pret', 'Voir les pièces compatibles');
      cta.removeAttribute('data-sans-modele');
      setCta(false);
      cta.removeAttribute('data-url');
      if (summary) summary.hidden = true;
      if (empty) empty.hidden = true;
    }

    function showEmpty(text) {
      if (!empty) return;
      empty.hidden = false;
      if (emptyText) emptyText.textContent = text;
    }

    brandSel.addEventListener('change', function () {
      resetModels();
      var sm = sansModeleChoisi();
      if (sm) {
        track('brand_sans_modele', { brand: sm.handle });
        modelSel.options[0].textContent = 'Pas de modèle à choisir';
        cta.setAttribute('data-libelle-pret', 'Voir les produits ' + sm.label);
        setCta(true);
        cta.setAttribute('data-url', sm.url);
        cta.setAttribute('data-sans-modele', 'true');
        if (sBrand) sBrand.textContent = sm.label;
        if (sModel) sModel.textContent = sm.metier || '';
        if (sType) sType.hidden = true;
        if (sCount) sCount.hidden = true;
        if (summary) summary.hidden = false;
        return;
      }
      var b = brands.filter(function (x) { return x.handle === brandSel.value; })[0];
      if (!b) return;
      track('brand_select', { brand: b.handle });
      var active = b.models.filter(function (m) { return m.active; });
      if (!active.length) {
        track('brand_no_model', { brand: b.handle });
        showEmpty('Cette marque est bien connue, mais ce modèle n’est pas encore disponible en ligne.');
        return;
      }
      active.forEach(function (m) {
        var opt = document.createElement('option');
        opt.value = m.handle;
        opt.textContent = m.label;
        opt.setAttribute('data-url', m.url);
        opt.setAttribute('data-type', m.type);
        opt.setAttribute('data-schemas', m.schemas);
        opt.setAttribute('data-parts', m.parts);
        modelSel.appendChild(opt);
      });
      modelSel.disabled = false;
    });

    modelSel.addEventListener('change', function () {
      var opt = modelSel.options[modelSel.selectedIndex];
      var url = opt ? opt.getAttribute('data-url') : null;
      if (!url) { setCta(false); if (summary) summary.hidden = true; return; }
      track('model_select', { brand: brandSel.value, model: modelSel.value });
      setCta(true);
      cta.setAttribute('data-url', url);
      // Carte resume
      if (sBrand) sBrand.textContent = brandSel.options[brandSel.selectedIndex].textContent;
      if (sModel) sModel.textContent = opt.textContent;
      var type = opt.getAttribute('data-type');
      if (sType) {
        var resolvedType = typeLabel(type);
        if (resolvedType) { sType.textContent = resolvedType; sType.hidden = false; }
        else { sType.hidden = true; }
      }
      // Compteur: seulement si fiable ET non provisoire
      var schemas = opt.getAttribute('data-schemas');
      var parts = opt.getAttribute('data-parts');
      if (sCount) {
        if (!provisional && (schemas || parts)) {
          var bits = [];
          if (schemas) bits.push(schemas + (schemas === '1' ? ' schéma' : ' schémas'));
          if (parts) bits.push(parts + (parts === '1' ? ' pièce' : ' pièces'));
          sCount.textContent = bits.join(' · ');
          sCount.hidden = false;
        } else {
          sCount.hidden = true;
        }
      }
      if (summary) summary.hidden = false;
    });

    cta.addEventListener('click', function () {
      var url = cta.getAttribute('data-url');
      if (!url) {
        // Touche trop tot : le focus va sur la liste a remplir.
        (brandSel.value && !modelSel.disabled ? modelSel : brandSel).focus();
        return;
      }
      if (cta.getAttribute('data-sans-modele') === 'true') {
        track('cta_sans_modele', { brand: brandSel.value });
        window.location.href = url;
        return;
      }
      track('cta_schemas', { brand: brandSel.value, model: modelSel.value });
      if (window.KrepiteDeviceMemory) {
        var modelOpt = modelSel.options[modelSel.selectedIndex];
        window.KrepiteDeviceMemory.set({
          model_handle: modelSel.value,
          brand_handle: brandSel.value,
          brand_label: brandSel.options[brandSel.selectedIndex].textContent,
          model_label: modelOpt ? modelOpt.textContent : '',
          variant: null
        });
      }
      window.location.href = url;
    });
  }

  // Cartes "marques populaires": pre-selection dans le finder si la marque existe
  // dans le catalog; sinon on laisse le lien <a> naviguer (fallback jamais casse).
  function wireBrandJumps() {
    document.querySelectorAll('[data-kfmm-brand-jump]').forEach(function (card) {
      card.addEventListener('click', function () {
        track('brand_card', { brand: card.getAttribute('data-kfmm-brand-jump') || '' });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    routeMode();
    document.querySelectorAll('[data-kbmf]').forEach(init);
    wireBrandJumps();
    // Tracking sorties de secours
    document.querySelectorAll('a[href*="identifier-mon-poele"]').forEach(function (a) {
      a.addEventListener('click', function () { track('cta_photo', {}); });
    });
    document.querySelectorAll('a[href*="view=trouver-piece-v3"]').forEach(function (a) {
      a.addEventListener('click', function () { track('cta_catalogue', {}); });
    });
  });
})();
